import React from 'react';
import { Helmet } from 'react-helmet';
import Home from './home';
export default (function () { return [
    React.createElement(Helmet, { key: "Index" },
        React.createElement("title", null, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u044B \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0437\u0430\u0440\u044F\u0434\u043D\u044B\u043C\u0438 \u0441\u0442\u0430\u043D\u0446\u0438\u044F\u043C\u0438 \u0434\u043B\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043C\u043E\u0431\u0438\u043B\u0435\u0439")),
    React.createElement(Home, { key: "IndexComponent" })
]; });
